import {
  Center,
  HStack,
  Text,
  NumberInput,
  NumberInputField,
  NumberIncrementStepper,
  NumberInputStepper,
  NumberDecrementStepper,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';

import {
  date as commonDate,
  utils as commonUtils,
} from '@finley-technologies/common';
import { Util } from '@finley-technologies/finley-types';

import { Select } from 'packages/common-frontend/components/Select';
import { SimpleDatePicker } from 'packages/common-frontend/components/SimpleDatePicker';

export type CreditAgreementSelectKey = 'latestCommitted' | 'wip';

type CreditAgreementSelectionProps = {
  hasWip: boolean;
  onChange: (params: {
    creditAgreementSelection: CreditAgreementSelectKey;
    reportingDate: Util.FullDateStr;
    fileVersion: number;
  }) => void;
};
export const CreditAgreementSelection = ({
  hasWip,
  onChange,
}: CreditAgreementSelectionProps) => {
  const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const [
    selectedCreditAgreementKey,
    setSelectedCreditAgreementKey,
  ] = useState<CreditAgreementSelectKey>('latestCommitted');

  const [
    selectedReportingDate,
    setSelectedReportingDate,
  ] = useState<Util.FullDateStr>(commonDate.currentDateStr());
  const [selectedFileVersion, setSelectedFileVersion] = useState<number>(1);

  const selections = ['latestCommitted', 'wip'] as const;
  useEffect(() => {
    setSelectedCreditAgreementKey(hasWip ? 'wip' : 'latestCommitted');
  }, [hasWip]);

  useEffect(() => {
    onChange({
      creditAgreementSelection: selectedCreditAgreementKey,
      reportingDate: selectedReportingDate,
      fileVersion: selectedFileVersion,
    });
    // this hook depends on onChange, but adding that to dependency
    // causes infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCreditAgreementKey, selectedReportingDate, selectedFileVersion]);
  return (
    <HStack>
      <Center>
        <Text display="inline" mr="15px">
          Credit Agreement
        </Text>
        <Select
          value={selectedCreditAgreementKey}
          options={selections.map((creditAgreementSelection) => {
            return {
              value: creditAgreementSelection,
              label: commonUtils.toTitleCase(creditAgreementSelection),
            };
          })}
          onChange={(currentSelectedCreditAgreement) => {
            if (currentSelectedCreditAgreement)
              setSelectedCreditAgreementKey(currentSelectedCreditAgreement);
          }}
          isDisabled={!hasWip}
        />
        <Text mr="10px">reporting date:</Text>
        <SimpleDatePicker
          tz={clientTimeZone}
          selectedDate={commonDate.fullDateStrToDate(selectedReportingDate)}
          showTimeSelect={false}
          setSelectedDate={(date: Date | null) => {
            const fullDateStr = commonDate.dateToFullDateString(
              date ?? new Date(),
              clientTimeZone,
            );
            setSelectedReportingDate(fullDateStr);
          }}
          width="150px"
        />
        <Text mr="10px">file verison:</Text>
        <NumberInput
          size="md"
          maxW={24}
          defaultValue={1}
          min={1}
          max={20}
          value={selectedFileVersion}
          onChange={(value: string) => {
            setSelectedFileVersion(Number(value));
          }}
        >
          <NumberInputField />
          <NumberInputStepper>
            <NumberIncrementStepper />
            <NumberDecrementStepper />
          </NumberInputStepper>
        </NumberInput>
      </Center>
    </HStack>
  );
};
